module.exports = require("core-js/modules/es.typed-array.to-locale-string.js");